import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

const SafeIconGray: React.FC<SvgProps> = ({ width = 57, height = 57 }) => {
  const { theme } = useTheme()

  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75Z"
        stroke={theme.iconPrimary}
        stroke-width="1.5"
      />
      <Path
        d="M16.4135 12.1523H15.329C15.0054 12.1523 14.7426 12.4226 14.7426 12.7569V14.3794C14.7426 14.7129 14.4798 14.984 14.1563 14.984H9.84317C9.51965 14.984 9.25684 15.2543 9.25684 15.5886V16.7063C9.25684 17.0397 9.51965 17.3108 9.84317 17.3108H14.4066C14.7301 17.3108 14.9888 17.0406 14.9888 16.7063V15.8098C14.9888 15.4763 15.2516 15.2393 15.5751 15.2393H16.4135C16.737 15.2393 16.9998 14.969 16.9998 14.6347V12.7511C16.9998 12.4176 16.737 12.154 16.4135 12.154V12.1523Z"
        fill={theme.iconPrimary}
      />
      <Path
        d="M9.25719 9.93143C9.25719 9.59796 9.52 9.32685 9.84353 9.32685H14.1541C14.4777 9.32685 14.7405 9.05658 14.7405 8.72227V7.60458C14.7405 7.27111 14.4785 7 14.1541 7H9.59319C9.26966 7 9.00685 7.27027 9.00685 7.60458V8.4653C9.00685 8.79878 8.74487 9.06988 8.42052 9.06988H7.58634C7.26281 9.06988 7 9.34016 7 9.67447V11.5606C7 11.894 7.26364 12.151 7.58717 12.151H8.67168C8.99521 12.151 9.25802 11.8807 9.25802 11.5464V9.9306H9.25719V9.93143Z"
        fill={theme.iconPrimary}
      />
      <Path
        d="M11.4901 10.9775H12.5314C12.8707 10.9775 13.146 11.262 13.146 11.6112V12.6848C13.146 13.0349 12.8707 13.3185 12.5314 13.3185H11.4901C11.1508 13.3185 10.8755 13.0341 10.8755 12.6848V11.6112C10.8755 11.2611 11.1508 10.9775 11.4901 10.9775Z"
        fill={theme.iconPrimary}
      />
    </Svg>
  )
}

export default React.memo(SafeIconGray)
